import type { SiteStat } from "@/lib/content";

/**
 * Numeric figures come from `site_stats` and are only ever returned when the
 * row is published AND substantiated — no count, dollar amount, or outcome
 * claim reaches the public site without a documented basis on file.
 *
 * The two static items below are factual descriptors, not claims, so they are
 * hardcoded and always render.
 */
const STATIC_ITEMS = [
  "AI strategy · implementation · automation",
  "Serving clients nationwide",
] as const;

export function TrustBar({ stats = [] }: { stats?: SiteStat[] }) {
  return (
    <section className="w-full border-y border-ink-200 bg-paper-100">
      <div style={{ paddingInline: "clamp(20px, 5vw, 48px)" }}>
        <ul className="flex min-h-[70px] items-center gap-x-10 gap-y-2 overflow-x-auto whitespace-nowrap py-4 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
          {stats.map((stat) => (
            <li
              key={stat.id}
              className="flex shrink-0 items-center gap-2.5 text-body-sm text-ink-600"
            >
              <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-brand-600" aria-hidden="true" />
              <span>
                <span className="tabular font-semibold text-ink-900">{stat.value}</span>{" "}
                {stat.label}
              </span>
            </li>
          ))}
          {STATIC_ITEMS.map((label) => (
            <li
              key={label}
              className="flex shrink-0 items-center gap-2.5 text-body-sm text-ink-600"
            >
              <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-brand-600" aria-hidden="true" />
              <span>{label}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}

export default TrustBar;
